import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { OHeader, OCookieConsent, OFooter } from '../components/organisme';
import HouseHoldRouting from './household.routing';
import IndustrialRouting from './industrial.routing';
import { IntroPage, ErrorPage, TemplatePage } from '../pages';
import { routes } from '../constants';
import { checkCookieConsent, consetToCookie } from '../redux/head/headActions';

const mapStateToProps = state => ({
	items: state.content.category,
	isFetching: state.content.isFetching,
	lang: state.head.language,
	theme: state.head.navigation,
	consent: state.head.consent,
});

class AppRouting extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			lang: 'nl',
			theme: undefined,
			consent: false,
		};

		this.bindHandles();
	}

	componentDidMount() {
		this.props.checkCookieConsent();
	}

	componentWillReceiveProps(props) {
		for (const key in this.state) {
			if (key in props && props[key] !== this.state[key]) {
				this.setState({ [key]: props[key] });
			}
		}
	}

	bindHandles() {
		this.handleConsent = this.handleConsent.bind(this);
	}

	handleConsent() {
		this.props.consetToCookie();
	}

	render() {
		let consent;

		if (!this.state.consent) {
			consent = <OCookieConsent onClick={this.handleConsent} />;
		}

		return (
			<TemplatePage>
				<OHeader
					lang={this.state.lang}
					theme={this.state.theme}
				/>
				<div className="main-tag-polyfill-IE">
					<Switch>
						<Route path={routes.HOUSEHOLD.HOME} component={HouseHoldRouting} />
						<Route path={routes.INDUSTRIAL.HOME} component={IndustrialRouting} />
						<Route path={routes.HOME} exact component={IntroPage} />
						<Route component={ErrorPage} />
					</Switch>
					{consent}
				</div>
				<OFooter
					theme={this.state.theme}
				/>
			</TemplatePage>
		);
	}
}

export default withRouter(connect(mapStateToProps, {
	checkCookieConsent,
	consetToCookie,
})(AppRouting));



// WEBPACK FOOTER //
// ./src/router/app.routing.js